import { render, staticRenderFns } from "./OptimizationResultRoutes.vue?vue&type=template&id=1939c6da"
import script from "./OptimizationResultRoutes.vue?vue&type=script&lang=js"
export * from "./OptimizationResultRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports